<template>
  <div class="hello">
    <van-swipe :autoplay="3000" :loop=false @change="onChange">
      <van-swipe-item v-for="(user, index) in list" :key="index">
        <!-- 直接使用animated中的动画class名，注意：必须使用animated这个class名，否则动画会无效 -->
        <div :class="['tit',{ animated: isActive1 },{ fadeInUp: isActive2 } ]">
          <h1>{{ user.title }}</h1>
          <p>{{ user.subtitle }}</p>
        </div>
        <van-button round type="info" v-show="index == 2" :class="[{ animated: isActive1 },{ fadeInUp: isActive2 } ]" @click="toHome">立即体验</van-button>
        <img :src="user.images" alt="" />
        <!-- <img v-lazy="image" /> -->
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import Vue from 'vue'
import { Swipe, SwipeItem, Lazyload, Button, Toast } from 'vant'
import 'vant/lib/index.css'
Vue.use(Lazyload)
export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Button.name]: Button,
    [Toast.name]: Toast
  },
  name: 'HelloWorld',
  props: {
    msg: String
  },
  mounted: function () {
    // setTimeout(() => {
    //   this.toHome()
    // }, 12000)
  },
  data () {
    return {
      isActive1: true,
      isActive2: true,
      // classObject: { animated: true, fadeInUp: true },
      images: [
        require('../assets/ydy1@3x.png'),
        require('../assets/ydy2@3x.png'),
        require('../assets/ydy3@3x.png')
      ],
      list: [
        {
          images: require('../assets/ydy1@3x.png'),
          title: '智慧电网',
          subtitle: '为电网领域提供综合解决方案'
        },
        {
          images: require('../assets/ydy2@3x.png'),
          title: '一站式服务',
          subtitle: '专注创新，量身打造，让服务零距离'
        },
        {
          images: require('../assets/ydy3@3x.png'),
          title: '主动运维',
          subtitle: '配网智能决策辅助系统'
        }
      ]
      // title: [
      //   '智慧电网', '一站式服务', '主动运维'
      // ],
      // subtitle: [
      //   '为电网领域提供综合解决方案', '专注创新，量身打造，让服务零距离', '配网智能决策辅助系统'
      // ]
    }
  },
  methods: {
    // 监听 change 事件
    onChange (index) {
      // Toast('当前 Swipe 索引：' + index)
      // if (index === 1) {
      //   setTimeout(() => {
      //     this.toHome()
      //   }, 12000)
      // } else if (index === 2) {
      //   setTimeout(() => {
      //     this.toHome()
      //   }, 8000)
      // } else if (index === 3) {
      //   setTimeout(() => {
      //     this.toHome()
      //   }, 4000)
      // }
      setTimeout(() => {
        this.isActive1 = false
        this.isActive2 = false
      }, 10)
      setTimeout(() => {
        this.isActive1 = true
        this.isActive2 = true
      }, 20)
    },
    toHome () {
      // clearInterval(this.timer)// 清除定时器
      // this.timer = null
      this.$router.push('/home')// 跳转到首页
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.hello {
  .tit {
    position: absolute;
    top: 12vh;
    left: 10vw;
    z-index: 2;
    text-align: left;
    color: #FFFFFF;
    h1 {
      font-size: 26px;
      color: #FFFFFF;
    }
    p {
      font-size: 15px;
      color: #FFFFFF;
    }
  }
  /deep/ .van-button {
    position: absolute;
    bottom: 10vh;
    left: 10vw;
    z-index: 2;
  }
  img {
    width: 100vw;
    height: 100vh;
  }
  /deep/.van-swipe__indicators {
    position: absolute;
    bottom: 5vh;
  }
  /deep/.van-swipe__indicator {
    width: 8px;
    height: 4px;
    background: #818486;
    border-radius: 3px;
  }
  /deep/.van-swipe__indicator--active {
    width: 20px;
    height:4px;
    background-color: #fff;
    opacity: 1;
  }
}
</style>
